module.exports = __webpack_public_path__ + "img/Chatapp2.04369ebe.jpg";